export default "__VITE_ASSET__DiI0Q$sa__"